import ibanLengths from './IbanLength';

const stripWhitespaces = (iban?: string): string => iban?.replace(/\s/g, '') ?? '';

const getCountryCodeFromIban = (iban: string): string => stripWhitespaces(iban).substr(0, 2);

const validLength = (iban: string): number => {
    const countryCode = getCountryCodeFromIban(iban);
    return countryCode in ibanLengths ? ibanLengths[countryCode] : Math.max(...Object.values(ibanLengths));
};

export const areDifferent = (previous?: string) => (next?: string): boolean =>
    Boolean(next && stripWhitespaces(next) !== stripWhitespaces(previous));

export const isValidLength = (iban?: string): boolean =>
    iban ? stripWhitespaces(iban).length === validLength(iban) : false;

export const isValidCountryCode = (iban?: string): boolean =>
    iban ? getCountryCodeFromIban(iban) in ibanLengths : false;
